@if (leadFormWebComponentCaptchaFeatureToggle()) {
  <div
    [id]="gRecaptchaId"
  ></div>
}
<luigi-container
  [viewurl]="url"
  id="dcp-lead-form-modal"
  webcomponent='{ "selfRegistered": true }'
  [context]="context"
></luigi-container>
